/* eslint-disable prettier/prettier */
import React from "react"
import "aos/dist/aos.css"
import "./cardStyle.css"

function CardLeft(props) {
  // AOS.init({
  //     // initialise with other settings
  //     duration : 2000,
  //     // offset:100
  //   });
  return (
    <div
      className="card mb-5 "
      data-aos={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
    >
      <div className="row eventcontainer">
        <div className="col-md-2 imagecontainer">
          <img src={props.imgUrl} alt="" className="img-fluid left" />
        </div>

        <div className="col-md-8">
          <div className="card-body">
            <h4 className="card-title">{props.Title}</h4>
            <div className="card-text">{props.Description}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default CardLeft
